var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-wrapper inner-content space-y-[10px]"},[(_vm.loggedIn)?_c('div',[_c('logged-in')],1):_c('div',[_c('guest',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]}),_c('GuestImproved')],1),_c('sorority-wars-fight-weekly-m-m',{staticClass:"p-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }